import React from 'react'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'

const ModalCase1 = ({
  amenitiesDefinitions,
  isOpen,
  master,
  childs,
  onSubmit,
  onUndo,
  dictionary,
}) => {
  // const { dictionary } = window.bookingData || window.modifyData

  const childsTitles = () => {
    return amenitiesDefinitions
      .filter((i) => childs.includes(i.code))
      .map((i) => i.name)
  }

  const masterTitle = () => {
    return master
      ? amenitiesDefinitions.find((i) => i.code === master).name
      : ''
  }

  const iconImage = () => {
    return master
      ? amenitiesDefinitions.find((i) => i.code === master).image
      : ''
  }

  const text = () => {
    const value = `<strong>${masterTitle()}</strong>`
    return dictionary.modalCase1Text.replace('{0}', value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(master, childs)
  }

  const handleUndo = (e) => {
    e.preventDefault()
    onUndo()
  }

  return (
    <div
      className={`modal s-modal s-modal--warning  ${
        isOpen ? 'show d-block' : ''
      }`}
      id="modalCase1">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title">
              {iconImage() && (
                <div>
                  {/* <i className="icon-warning"></i> */}
                  <img src={iconImage().url} alt={iconImage().alt} />
                </div>
              )}
              <div>{dictionary.modalCase1Title}</div>
            </div>
          </div>
          <div className="modal-body">
            <div>
              <SanitizeHtml tag="p" html={text()} />
            </div>
            <ul className="b-extras-as-badges-list">
              {childsTitles().map((child, index) => (
                <li key={index}>
                  <div className="e-extra-as-badge">{child}</div>
                </li>
              ))}
            </ul>
          </div>
          <div className="modal-footer">
            <ul>
              <li>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={handleUndo}
                  title={dictionary.modalCase1ButtonUndoText}>
                  {dictionary.modalCase1ButtonUndoText}
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  title={dictionary.modalCase1ButtonSubmitText}>
                  {dictionary.modalCase1ButtonSubmitText}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalCase1
